import {
  Button,
  FormDataConsumer,
  maxLength,
  NumberInput,
  required,
  SelectInput,
  TextInput,
  useNotify,
  useRefresh,
} from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import EditIcon from "@mui/icons-material/Edit";
import { Grid } from "@mui/material";
import dataProvider from "server/dataProvider";
import { CurriculumItemTypes } from "utils/constants";
import { CurriculumItemTypeChoices } from "utils/choices";
import { specialistRequests } from "api/specialistApi";

const UpdateItemDialog = ({ curriculumId, itemId, moduleId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    const payload = {
      type: data.type,
      nameBg: data.nameBg,
      nameEn: data.nameEn,
      durationHours: data.durationHours,
      moduleId,
    };
    await dataProvider.customRequest(specialistRequests.updateCurriculumItem(curriculumId, itemId), payload, "PUT");
    notify("Успешно редактирана тема", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Редакция на тема"
      dialogSize="md"
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label="Редактирай"
          variant="outlined"
          startIcon={<EditIcon />}
        />
      }
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="nameBg"
            label="Наименование (БГ)"
            validate={[required(), maxLength(500)]}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="nameEn"
            label="Наименование (EN)"
            validate={[maxLength(500)]}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <SelectInput
            source="type"
            label="Тип"
            choices={CurriculumItemTypeChoices}
            validate={[required()]}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <FormDataConsumer>
            {({ formData }) =>
              formData?.type !== CurriculumItemTypes.Colloquium && (
                <NumberInput
                  source="durationHours"
                  label="Часове продължителност"
                  validate={[required()]}
                  fullWidth
                  onWheel={e => e.target.blur()}
                />
              )
            }
          </FormDataConsumer>
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default UpdateItemDialog;
